<template>
    <div class="top-page">
        <!-- ヒーローセクション -->
        <div class="hero-section">
            <div class="container">
                <div class="hero-content">
                    <h1 class="hero-title">
                        <i class="fa-solid fa-house-chimney"></i>
                        ようこそ
                    </h1>
                    <p class="hero-subtitle">システムの主な機能をご案内します</p>
                </div>
            </div>
        </div>

        <!-- メインコンテンツ -->
        <div class="container main-content">
            <!-- 機能カードグリッド -->
            <div class="row g-4">
                <!-- 受注管理カード -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="feature-card">
                        <div class="card-icon orders">
                            <i class="fa-solid fa-screwdriver-wrench"></i>
                        </div>
                        <h3 class="card-title">ツール</h3>
                        <p class="card-description">
                            領収書管理の機能です。
                            領収書スキャン画像をインポートし、データ管理を行います。
                        </p>
                        <ul class="feature-list">
                            <li><i class="fa-solid fa-check"></i> 新規領収書登録</li>
                            <li><i class="fa-solid fa-check"></i> 領収書一覧</li>
                            <li><i class="fa-solid fa-check"></i> 領収書閲覧</li>
                        </ul>
                    </div>
                </div>

                <!-- 顧客管理カード -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="feature-card">
                        <div class="card-icon customers">
                            <i class="fa-solid fa-database"></i>
                        </div>
                        <h3 class="card-title">マスタ</h3>
                        <p class="card-description">
                            マスタ管理機能です。
                            一部のマスタはCSVを出力し、編集したCSVをインポートすることで一括更新できます。
                        </p>
                        <ul class="feature-list">
                            <li><i class="fa-solid fa-check"></i> 取引先マスタ</li>
                            <li><i class="fa-solid fa-check"></i> 勘定科目マスタ</li>
                            <li><i class="fa-solid fa-check"></i> 税区分マスタ</li>
                            <li><i class="fa-solid fa-check"></i> 相手科目マスタ</li>
                            <li><i class="fa-solid fa-check"></i> タグマスタ</li>
                        </ul>
                    </div>
                </div>

                <!-- レポートカード -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="feature-card">
                        <div class="card-icon reports">
                            <i class="fa-solid fa-unlock"></i>
                        </div>
                        <h3 class="card-title">管理</h3>
                        <p class="card-description">
                            システム管理機能です。
                        </p>
                        <ul class="feature-list">
                            <li><i class="fa-solid fa-check"></i> メニューマスタ</li>
                            <li><i class="fa-solid fa-check"></i> ユーザー管理</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopPage',
    mounted() {
        // カードのフェードインアニメーション
        this.animateCards();
    },
    methods: {
        animateCards() {
            const cards = document.querySelectorAll('.feature-card');
            cards.forEach((card, index) => {
                setTimeout(() => {
                    card.classList.add('fade-in');
                }, index * 100);
            });
        }
    }
}
</script>

<style scoped>
.top-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* ヒーローセクション */
.hero-section {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
    padding: 4rem 0;
    margin-bottom: 3rem;
    box-shadow: var(--shadow-lg);
}

.hero-content {
    text-align: center;
    color: white;
}

.hero-title {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hero-title i {
    margin-right: 1rem;
}

.hero-subtitle {
    font-size: 1.25rem;
    font-weight: 300;
    opacity: 0.95;
}

/* メインコンテンツ */
.main-content {
    padding: 0 1rem;
}

/* 機能カード */
.feature-card {
    background: var(--card-bg);
    border-radius: 1rem;
    padding: 2rem;
    height: 100%;
    box-shadow: var(--shadow-md);
    transition: all 0.3s ease;
    opacity: 0;
    transform: translateY(20px);
}

.feature-card.fade-in {
    opacity: 1;
    transform: translateY(0);
}

.feature-card:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-xl);
}

.card-icon {
    width: 4rem;
    height: 4rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: white;
}

.card-icon.orders {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.card-icon.customers {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.card-icon.reports {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.card-icon.settings {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.card-icon.integration {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.card-icon.support {
    background: linear-gradient(135deg, #30cfd0 0%, #330867 100%);
}

.card-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 1rem;
}

.card-description {
    color: var(--text-secondary);
    line-height: 1.6;
    margin-bottom: 1.5rem;
}

.feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.feature-list li {
    padding: 0.5rem 0;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
}

.feature-list li i {
    color: var(--success-color);
    margin-right: 0.75rem;
    font-size: 0.875rem;
}

/* お知らせセクション */
.notice-section {
    background: var(--card-bg);
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: var(--shadow-md);
}

.notice-header {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid var(--border-color);
}

.notice-header i {
    font-size: 1.5rem;
    color: var(--primary-color);
    margin-right: 1rem;
}

.notice-header h2 {
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
}

.notice-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.notice-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    background: var(--light-bg);
    border-radius: 0.5rem;
    transition: background 0.2s ease;
}

.notice-item:hover {
    background: #edf2f7;
}

.notice-date {
    font-size: 0.875rem;
    color: var(--text-secondary);
    font-weight: 600;
    min-width: 100px;
}

.notice-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: 700;
    margin-left: 0.5rem;
    margin-right: 1rem;
}

.notice-badge.new {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
}

.notice-text {
    margin: 0;
    color: var(--text-primary);
    flex: 1;
}

/* クイックアクション */
.quick-actions {
    background: var(--card-bg);
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: var(--shadow-md);
}

.quick-actions-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 1.5rem;
    text-align: center;
}

.action-buttons {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.action-btn {
    padding: 1rem 1.5rem;
    border: none;
    border-radius: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    box-shadow: var(--shadow-sm);
}

.action-btn:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
}

.action-btn.primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.action-btn.secondary {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.action-btn.tertiary {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.action-btn.quaternary {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
    .hero-title {
        font-size: 2rem;
    }

    .hero-subtitle {
        font-size: 1rem;
    }

    .hero-section {
        padding: 2rem 0;
        margin-bottom: 2rem;
    }

    .feature-card {
        padding: 1.5rem;
    }

    .notice-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .notice-date {
        margin-bottom: 0.5rem;
    }

    .notice-badge {
        margin-left: 0;
        margin-bottom: 0.5rem;
    }

    .action-buttons {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 576px) {
    .card-icon {
        width: 3rem;
        height: 3rem;
        font-size: 1.5rem;
    }

    .card-title {
        font-size: 1.25rem;
    }
}
</style>
